__turbopack_context__.v({
  "bubbleTooltip": "_6Qve9G_bubbleTooltip",
  "htmlRenderer": "_6Qve9G_htmlRenderer",
  "instagramEmbed": "_6Qve9G_instagramEmbed",
  "mention": "_6Qve9G_mention",
  "richTextEditor": "_6Qve9G_richTextEditor",
  "strawPollEmbed": "_6Qve9G_strawPollEmbed",
});
